import { AccountBalanceOutlined, CalendarMonthOutlined, PlaceOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { Event, EventMapItem } from '../../../types/Event';
import { UserConfigurableModule } from '../../../types/User';
import { humanizeEventDateTimes } from '../../../utility/dateUtils';
import DrawerLink from '../../common/drawers/ModuleDrawer/DrawerLink';
import {
  eventMapTileContainerStyles,
  eventMapTileHeaderSectionStyles,
  eventMapTileHeaderStyles,
  eventMapTileSecondaryIconStyles,
  eventMapTileSecondaryLabelStyles,
  eventMapTileSecondaryStyles,
  eventMapTileSectionStyles,
  eventMapTileTextContainerStyles,
} from './eventMapStyles';

interface Props {
  mapEvent: EventMapItem;
}

export default function EventMapTile({ mapEvent }: Props) {
  const dateLabel = humanizeEventDateTimes(mapEvent as unknown as Event);

  return (
    <Box sx={eventMapTileContainerStyles}>
      <Box sx={eventMapTileSectionStyles}>
        <Box sx={eventMapTileHeaderSectionStyles}>
          <DrawerLink module={UserConfigurableModule.EVENTS} uuid={mapEvent.uuid}>
            <Typography title={mapEvent.name} sx={eventMapTileHeaderStyles}>
              {mapEvent.name}
            </Typography>
          </DrawerLink>
        </Box>

        <Box sx={eventMapTileTextContainerStyles}>
          <Box sx={eventMapTileSecondaryStyles}>
            <CalendarMonthOutlined sx={eventMapTileSecondaryIconStyles} />

            <Typography
              title={dateLabel}
              sx={{
                ...eventMapTileSecondaryLabelStyles,
                textDecoration: 'none',
              }}
            >
              {dateLabel}
            </Typography>
          </Box>

          <Box sx={eventMapTileSecondaryStyles}>
            <AccountBalanceOutlined sx={eventMapTileSecondaryIconStyles} />

            <DrawerLink module={UserConfigurableModule.ACCOUNTS} uuid={mapEvent.account_uuid}>
              <Typography title={mapEvent.account_display_name} sx={eventMapTileSecondaryLabelStyles}>
                {mapEvent.account_display_name}
              </Typography>
            </DrawerLink>
          </Box>

          <Box sx={eventMapTileSecondaryStyles}>
            <PlaceOutlined sx={eventMapTileSecondaryIconStyles} />

            <Typography title={mapEvent.formatted_address} sx={eventMapTileSecondaryLabelStyles}>
              {mapEvent.formatted_address}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
